import {GifActions} from "../constants/gifActions";

const INITIAL_STATE = {
    newGif : undefined,
    gifPost: undefined,
    gifs : [],
    searchText: undefined
};
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
            case GifActions.ADD_GIF :
                return {
                ...state,
                newGif: action.payload.gif,
                    gifs :[...state.gifs , action.payload.gif]
                };
            case GifActions.ADD_FAVORITE :
                return {
                ...state,
                gifPost: action.payload.gifPost
                };
            case GifActions.DELETE_FAVORITE :
                return {
                ...state,
                    gifPost: action.payload.gifPost
                };
            case GifActions.GET_GIF:
                return { ...state, errorMessage: action.payload , gifs :[ ...state.gifs, action.payload.gifPost] };
            case GifActions.GIF_ERROR:
                return { ...state, errorMessage: action.payload };
            case GifActions.SEARCH:
                return { ...state, searchText: action.payload.searchText };
            default:
                return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/gif.ts